import { useUserStore } from '@/stores/index.js';

// 判断是否是 VIP 用户
export function isUserVip(): boolean {
  const userStore = useUserStore();
  return userStore?.userInfo?.isVip;
}

// 判断是否是企业用户
export function isUserCompany(): boolean {
  const userStore = useUserStore();
  return userStore?.userInfo?.isCompany || false;
}
// 判断是否意管理员角色
export function isAdminRole(): boolean {
  const userStore = useUserStore();
  return userStore?.userInfo?.roles?.some(item => item.roleCode === 'admin') || false;
}

// 返回用户角色名称数组
export function getUserRoleNames(): string[] {
  const userStore = useUserStore();
  return userStore?.userInfo?.roles?.map(item => item.roleCode) || [];
}

const EMPTY_PROFILE_PICTURES = new Set([
  '',
  '0',
  'null',
  'undefined',
  '/images/user.png',
  'images/user.png',
]);
export const PROFILE_PICTURE_FILE_BASE_URL = 'https://ccnetcore.com/prod-api/file/';

export function hasProfilePicture(icon?: string | null): boolean {
  if (typeof icon !== 'string') return false;
  return !EMPTY_PROFILE_PICTURES.has(icon.trim().toLowerCase());
}

// 上传头像保存文件标识，内置头像直接保存完整链接。
export function getProfilePictureUrl(icon?: string | null): string {
  if (!hasProfilePicture(icon)) return '';
  const normalizedIcon = icon!.trim();
  if (/^https?:\/\//i.test(normalizedIcon)) return normalizedIcon;
  return `${PROFILE_PICTURE_FILE_BASE_URL}${normalizedIcon.replace(/^\/+/, '')}`;
}

export function getProfileInitial(nick?: string | null, userName?: string | null): string {
  const displayName = [nick, userName]
    .find(value => typeof value === 'string' && value.trim())
    ?.trim();
  return displayName ? Array.from(displayName)[0]!.toUpperCase() : '？';
}

// 用户头像
export function getUserProfilePicture(): string {
  const userStore = useUserStore();
  return getProfilePictureUrl(userStore.userInfo?.user?.icon);
}

export function getUserProfileInitial(): string {
  const userStore = useUserStore();
  return getProfileInitial(
    userStore.userInfo?.user?.nick,
    userStore.userInfo?.user?.userName,
  );
}
// 系统头像（可以常量）
export const systemProfilePicture = `/images/logo.png`;

// 获取微信二维码类型
// 获取二维码 LoginOrRegister 登录注册, Bind 绑定
export const WECHAT_QRCODE_TYPE = {
  LoginOrRegister: 'LoginOrRegister',
  Bind: 'Bind',
};
